import { DataProductCreateRequest } from "./data-product-create.request";

export class DataProductUpdateRequest extends DataProductCreateRequest {
    public idDataProduct: number;    
}